export const CLICK_ACTIONS = {
  INSERT_BLOCK: 'INSERT_BLOCK',
};

export const POSITIONS = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
};
